export default __webpack_public_path__ + "static/media/filter.1d945b91.svg";